/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicationHealthAlert {
    getFixupPrototypeFunction() { return ApplicationHealthAlert.fixupPrototype; }

    static newInstance(model: Partial<ApplicationHealthAlert>): ApplicationHealthAlert {
        let obj = Object.assign(new ApplicationHealthAlert(), model);
        ApplicationHealthAlert.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicationHealthAlert>): ApplicationHealthAlert {
        if (!model) return null;
        return ApplicationHealthAlert.newInstance(<ApplicationHealthAlert> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicationHealthAlert) {
        if (!obj) return;

        models.ApplicationHealthAlert.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicationHealthAlert): boolean {
        Object.setPrototypeOf(obj, ApplicationHealthAlert.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metric_value === undefined) {
            this.metric_value = 0;
        }
        if (typeof this.event_creation_time === "string") {
            this.event_creation_time = new Date(<string><any>this.event_creation_time);
        }
    }

    /**
     * Name of the metric
     */
    metric_name: string;

    /**
     * Alert status
     */
    status: string;

    /**
     * Metric value
     */
    metric_value: number;

    /**
     * Configured threshold
     */
    threshold: string;

    /**
     * Operator used for comparison
     */
    operator: models.AlertOperator;

    /**
     * Window size for evaluation
     */
    window_size: string;

    /**
     * Time aggregation type
     */
    time_aggregation: string;

    /**
     * Whether the alert requires immediate action
     */
    is_critical: boolean;

    /**
     * Timestamp of the event
     */
    event_creation_time: Date;

}
